(function($){
  var lastScrollTop = 0;
  var ticking = false;

  function headerH(){
    return $('#shopify-section-header').outerHeight() || 0;
  }

  function applyOffsets(){
    var h = headerH();
    $('body').css('padding-top', h);
    if ($('body').hasClass('hide-sticky')) {
      $('#CartDrawer, #NavDrawer').css('top', 0);
    } else {
      $('#CartDrawer, #NavDrawer').css('top', h);
    }
  }

  // initial layout settle
  $(window).on('load', applyOffsets);
  setTimeout(applyOffsets, 200);
  $(window).on('resize', applyOffsets);

  $(window).on('scroll', function(){
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function(){
      var st = $(window).scrollTop();
      var h  = headerH();

      // scroll richting
      if (st < lastScrollTop) {
        // omhoog
        if (st > h) $('body').removeClass('hide-sticky');
      } else {
        // omlaag
        if (st > h && $('.js-drawer-open').length === 0) {
          $('body').addClass('hide-sticky');
        }
      }
      lastScrollTop = Math.max(st, 0);

      applyOffsets();
      ticking = false;
    });
  });

  // PDP-specifiek gedrag (zoals je had), maar zonder -40
  if ($('.template-product').length > 0) {
    $(window).on('scroll.pdp', function(){
      var st = $(window).scrollTop();
      var h  = headerH();
      if (st < h) {
        $('body').removeClass('hide-sticky');
      } else {
        $('body').addClass('hide-sticky');
      }
      applyOffsets();
    });
  }

  // jouw search-modal code blijft verder OK
  $('.js-toggle-search-modal[data-mfp-src]').on('click', function() {
    setTimeout(function(){
      if ($('.mfp-bg').length > 0) $('body').addClass('search-open');
    }, 100);
  });

})(jQuery);
